$(function () {
    $('[data-auto-submit]').on('change', function () {
        $(this).parents('form').submit();
    });
});
